import React from 'react';
import mission from '../../img/mission.png';
import vision from '../../img/vision.png';

const MissionVision = () => {
    return (
        <div className='my-4 px-4 md:px-12'>
            <h1 className='my-12 md:text-6xl text-center text-3xl font-semibold'>Our Mission & Vision</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12'>
                <div className='flex justify-center'><img className='' src={mission} alt="mission" /></div>
                <div className='mt-4'>
                    <div className='mb-1 h-1 w-20 bg-red-400'></div>
                    <h1 className='md:text-5xl font-semibold text-left text-2xl '>Mission</h1>
                    <p className='mt-2 text-sm text-justify'>We're on a mission to provide the most accurate and helpful career guidance and counseling to the student so that they can find their perfect, happy, and fulfilling careers and make the right decision to become a successful person and find the best career opportunities.</p>
                </div>
            </div>

            <div className='grid grid-cols-1 md:flex md:flex-row-reverse gap-4 mt-12'>
                <div className='flex flex-1 justify-center'><img className='' src={vision} alt="vision" /></div>
                <div className='mt-4 flex-1 relative md:mt-10'>
                    <div className='mb-1 right-1 absolute h-1 w-20 bg-indigo-400'></div>
                    <h1 className='md:text-5xl font-semibold text-right text-2xl mt-1'>Vision</h1>
                    <p className='mt-2 text-sm text-justify'>Our vision is to make a difference in the lives of the student by providing them the best career guidance and counselling services. We want to be the most trusted and accurate career guidance and counselling company to provide the best possible way for people to find their career path and to help them succeed in their chosen field.</p>
                </div>
            </div>
        </div>
    );
};

export default MissionVision;